(function () {
  function init(root) {
    const viewport = root.querySelector('.hs-carousel__viewport');
    const track = root.querySelector('.hs-carousel__track');
    if (!viewport || !track) return;

    if (root.dataset.inited === '1') return;
    root.dataset.inited = '1';

    const items = Array.from(track.children);
    if (!items.length) return;

    const gap = 16;
    let pos = 0;
    let speed = 1;
    let pauseUntil = 0;

    let dragging = false;
    let startX = 0;
    let startPos = 0;

    // ▼ クリック判定用
    let downX = 0;
    let moved = false;
    const MOVE_TH = 10;

    // ▼ 押したときのリンク保持
    let downHref = null;

    items.forEach(el => {
      const c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    });

    function widthOfOne() {
      const r = items[0].getBoundingClientRect();
      return r.width + gap;
    }

    function totalWidth() {
      return widthOfOne() * items.length;
    }

    function wrap() {
      const w = totalWidth();
      if (!w) return;
      if (pos <= -w) pos += w;
      if (pos > 0) pos -= w;
    }

    function pause(ms) {
      pauseUntil = Date.now() + ms;
    }

    function tick() {
      if (!dragging && Date.now() > pauseUntil) {
        pos -= speed;
        wrap();
      }
      track.style.transform = `translate3d(${pos}px,0,0)`;
      requestAnimationFrame(tick);
    }
    tick();

    viewport.addEventListener('pointerdown', e => {
      dragging = true;
      startX = e.clientX;
      startPos = pos;
      pause(1500);

      downX = e.clientX;
      moved = false;

      // ★ 押した瞬間に data-href を確保
      const el = e.target.closest('[data-href]');
      downHref = el ? el.getAttribute('data-href') : null;

      viewport.setPointerCapture(e.pointerId);
    });

    viewport.addEventListener('pointermove', e => {
      if (!dragging) return;

      if (Math.abs(e.clientX - downX) > MOVE_TH) moved = true;

      pos = startPos + (e.clientX - startX);
      wrap();
    });

    function end() {
      // ★ スワイプでなければリンク遷移
      if (!moved && downHref) {
        location.href = downHref;
      }

      dragging = false;
      pause(1500);
      downHref = null;
    }

    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
  }

  function boot() {
    document.querySelectorAll('[data-hs-carousel]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
